import { render, staticRenderFns } from "./SignOffsListItem.vue?vue&type=template&id=2ebb5dd7&"
import script from "./SignOffsListItem.vue?vue&type=script&lang=js&"
export * from "./SignOffsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports